import React, { useState } from 'react';
import { getAsmtById, updateAsmtUsrById } from '../../services/authService';
import Questionnaire from './Questinaire';
import { decodeId } from '../../utills/idUtils';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import QualitativeFeedback from './section3';

const SelfAssesSubmit = ({ initiator, isReportShow, assessmentType,setIsReportShow }) => {
    const { encodedId } = useParams();
    const navigate = useNavigate()
    const id = decodeId(encodedId)
    // console.log("endcoded id", id)
    const [submitted, setSubmitted] = useState(false);
    const handleSubmit = async (formData, id, userId) => {
        // ////console.log("here", formData, id, userId)
        try {
            await updateAsmtUsrById(id, userId, formData);
            setSubmitted(true);
            localStorage.removeItem(`selfAssessment-${id}`)
            const getAsmtInitiatorId = await getAsmtById(id);
            if(getAsmtInitiatorId.assessment_type === "360" && getAsmtInitiatorId.current_status === "Completed"){
             setIsReportShow(true);
            }
            // console.log("line 21....",getAsmtInitiatorId);
            // window.location.reload();
        } catch (error) {
            console.error("Error submitting assessment:", error);
        }
    };

    // const handleShare = async () => {
    //     const shareData = {
    //         title: 'Check this out!',
    //         text: 'I found this interesting, take a look:',
    //         url: `${window.location.origin}/report/${encodedId}` // Share the custom URL instead of the current page URL
    //     };

    //     try {
    //         // Check if the Web Share API is supported
    //         if (navigator.share) {
    //             await navigator.share(shareData);
    //             //console.log('Successfully shared');
    //         } else {
    //             // Fallback if Web Share API is not supported
    //             alert('Web Share API is not supported in your browser. Try copying the link manually.');
    //         }
    //     } catch (error) {
    //         console.error('Error sharing:', error);
    //     }
    // };


    if (submitted) {
        return (
            <div className="text-center px-4 sm:px-6 lg:px-16 gap-8 my-8 lg:my10">
                {
                    assessmentType === "self" ? (
                        // SELF-ASSESSMENT BLOCK
                        <>
                            <img
                                className="w-45 lg:w-[20%] h-auto sm:w-48 sm:h-48 rounded-md mx-auto my-3"
                                src="https://images.pexels.com/photos/653429/pexels-photo-653429.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                                alt="Assessment Complete"
                            />
                            <div className="mx-auto p-8  bg-white rounded-2xl  lg:w-[60%] ">
                                <div className="title">Assessment Complete !</div>
                                {/* <div className="title">Assessment Complete !</div> */}
                                {/* <div className="subtitle">Congratulations! You’ve successfully completed the Executive Presence Assessment.</div> */}
                                <div className="subtitle">Congratulations! You’ve successfully completed the Executive Presence Assessment.
                                    Your personalized report is now ready. It contains insights and feedback to help you strengthen and elevate your executive presence.
                                </div>
                                {/* <div className="description">
                        Your personalized report is now ready. It contains insights and feedback to help you strengthen and elevate your executive presence.
                    </div> */}
                                {
                                    isReportShow ? <div className="mt-10 text-center">
                                        <button
                                            className="px-8 py-4 bg-blue-500 text-white text-lg font-semibold rounded-full    focus:outline-none focus:ring-4 focus:ring-indigo-300"
                                            onClick={() => navigate(`/report/${encodedId}`)}
                                        >
                                            Generate My Report
                                        </button>
                                    </div> : null
                                }

                                <div class="flex justify-center space-x-4 mt-8">
                                    {/* <Link to="/start-asmt">
                            <button
                                className="bg-gray-500 text-white font-medium py-2 px-6 rounded-lg hover:bg-blue-500 transition">Share with Your Connections
                            </button>
                        </Link> */}
                                    <Link to="/">
                                        <button className="bg-blue-500 text-white font-medium py-2 px-6 rounded-lg hover:bg-gray-500 transition">Home</button>
                                    </Link>
                                </div>
                            </div>
                        </>
                    ) : (




                        !initiator ? (
                            <>
                                <img
                                    className="w-45 lg:w-[20%] h-auto sm:w-48 sm:h-48 rounded-md mx-auto my-3"
                                    src="https://images.pexels.com/photos/653429/pexels-photo-653429.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                                    alt="Assessment Complete"
                                />
                                <div className="mx-auto p-8  bg-white rounded-2xl  lg:w-[60%] ">
                                    <div className="title">You have successfully completed your self-assessment!</div>
                                    {/* <div className="title">Assessment Complete !</div> */}
                                    {/* <div className="subtitle">Congratulations! You’ve successfully completed the Executive Presence Assessment.</div> */}
                                    <div className="subtitle">The 360-degree feedback report will be generated once all nominated respondents have submitted their feedback, or at the end of the designated feedback period—whichever comes first.</div>
                                    {/* <div className="description">
                                Your personalized report is now ready. It contains insights and feedback to help you strengthen and elevate your executive presence.
                            </div> */}
                                    {
                                        isReportShow ? <div className="mt-10 text-center">
                                            <button
                                                className="px-8 py-4 bg-blue-500 text-white text-lg font-semibold rounded-full    focus:outline-none focus:ring-4 focus:ring-indigo-300"
                                                onClick={() => navigate(`/report/${encodedId}`)}
                                            >
                                                Generate My Report
                                            </button>
                                        </div> : null
                                    }

                                    <div class="flex justify-center space-x-4 mt-8">
                                        {/* <Link to="/start-asmt">
                                    <button
                                        className="bg-gray-500 text-white font-medium py-2 px-6 rounded-lg hover:bg-blue-500 transition">Share with Your Connections
                                    </button>
                                </Link> */}
                                        <Link to="/">
                                            <button className="bg-blue-500 text-white font-medium py-2 px-6 rounded-lg hover:bg-gray-500 transition">Home</button>
                                        </Link>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
                                <div class="bg-white shadow-lg rounded-lg p-8  text-center">
                                    <div class="w-full h-48 lg:h-[500px]">
                                        <img class="w-full h-full object-cover object-top" src="https://images.pexels.com/photos/653429/pexels-photo-653429.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Feedback Recorded" />
                                    </div>

                                    <h1 class="text-2xl font-semibold text-gray-800 mt-6">Feedback Recorded!</h1>
                                    <p class="text-gray-600 mt-4">
                                        We have successfully recorded your feedback for <span class="font-medium text-gray-800">{initiator}</span>. Your insights are invaluable in providing a comprehensive evaluation.
                                    </p>

                                    <div class="mt-8">
                                        <h3 class="text-lg font-semibold text-gray-800">Confidentiality</h3>
                                        <p class="text-gray-600 mt-2">
                                            Your responses will remain private. Only a summary of the overall feedback will be shared with the initiator.
                                        </p>
                                    </div>

                                    <div class="mt-8 bg-blue-100 rounded-lg p-6">
                                        <h2 class="text-lg font-semibold text-blue-800">Interested in assessing your own executive presence?</h2>
                                        <Link to="/start-asmt">
                                            <button class="bg-blue-500 text-white font-medium py-2 px-6 rounded-lg mt-4 hover:bg-blue-600 transition">Start New Assessment</button>
                                        </Link>
                                    </div>

                                    <div class="flex justify-center space-x-4 mt-8">
                                        {/* <Link to="#">

                                    <button class="bg-blue-500 text-white font-medium py-2 px-6 rounded-lg hover:bg-blue-600 transition">Share with Your Connections</button>
                                </Link> */}
                                        <Link to="/">
                                            <button class="bg-gray-500 text-white font-medium py-2 px-6 rounded-lg hover:bg-gray-600 transition">Home</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        )
                    )
                }

            </div>
        );


    }

    return (
        <div className="flex flex-col items-center">
            <Questionnaire initiator={initiator} onSubmit={handleSubmit} />
        </div>
    );
};

export default SelfAssesSubmit;
